module.exports = __webpack_public_path__ + "static/media/ag.a605beb9.svg";